import { useCallback } from 'react';
import { useUser } from '~/api/hooks/useGetAccount';
import { fetchRecommendedProduct } from '~/api/hooks/useGetRecommendedProduct';
import { useRegion } from '~/features/region/hooks/useRegion';
import { useLocale } from '~/hooks/useLocale';
import { useSelectedChild } from '~/hooks/useSelectedChild';
import type { DateString } from '~/interfaces/common';
import { nowDate } from '~/utils/time';

export const useRecommendApi = () => {
  const { lang } = useLocale();
  const { data: user } = useUser();
  const { regionCode } = useRegion();

  const selectedChildID = useSelectedChild()?.child_id;
  if (typeof selectedChildID === 'undefined') {
    // 子供の情報を登録できずに登録完了したときは/registerに遷移させる
    window.location.href = '/register';
  }

  const getRecommended = useCallback(
    async ({
      isFirstLogin = false,
      date = nowDate(),
    }: {
      isFirstLogin?: boolean;
      date?: DateString;
    }) => {
      // user 未確定時は推奨取得をスキップ
      if (!user) return undefined;
      // SWRキャッシュに格納しつつAPIレスポンスを返す
      const res = await fetchRecommendedProduct({
        date,
        is_newbie: isFirstLogin,
        lang,
        child_id: user.selected_child_id,
        regionCode,
      });

      return res;
    },
    [user, lang, regionCode],
  );

  return { getRecommended };
};
